"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGovernanceForecastByMonths = exports.getFoundationHolding = exports.getSearchQuery = exports.getTransactionDetailsByTxhash = exports.getTransactionDetailsByHash = exports.getTransactionHistory = exports.getTransactionHistoryById = exports.getProposalsTimeseries = exports.getLedgerTimeseriesById = exports.getGovernanceAssetsById = exports.getGovernanceBalanceById = exports.getOrigynForecast = exports.getStakesTimeseries = exports.getUsersTimeseries = exports.getMetrics = exports.getMultiDatasCard = exports.getStakesByPrincipal = exports.getGovernanceStakesList = exports.getBalanceWithGovernanceList = exports.getGovernanceList = exports.getExchangeRateOGY = exports.getGovernanceMetrics = exports.getSupplyMetrics = exports.getBalanceListByPage = exports.getTokenDistribution = exports.getBurnedSupplyTimeseries = exports.getSupplyData = exports.getSupplyTimeseries = void 0;
const constants_1 = require("@/constants");
const format_1 = require("./format");
const url = constants_1.REST_API_BASE_URL;
const basePath = '/ogy';
const ROSETTA_URL = 'https://rosetta-ogy.origyn.ch';
const NET_ID = {
    blockchain: "ORIGYN Foundation",
    network: "00000000012000b90101",
};
const getSupplyTimeseries = async () => {
    const request = await fetch(`${url}${basePath}/supply/timeseries`);
    const response = await request.json();
    const formatedData = (0, format_1.formatSupplyTimeseries)(response);
    return formatedData;
};
exports.getSupplyTimeseries = getSupplyTimeseries;
const getSupplyData = async () => {
    const request = await fetch(`${url}${basePath}/supply/timeseries`);
    const response = await request.json();
    return response;
};
exports.getSupplyData = getSupplyData;
const getBurnedSupplyTimeseries = async () => {
    const request = await fetch(`${url}${basePath}/supply/burned`);
    const response = await request.json();
    const formatedData = (0, format_1.formatBurnedSupplyTimeseries)(response);
    return formatedData;
};
exports.getBurnedSupplyTimeseries = getBurnedSupplyTimeseries;
const getTokenDistribution = async () => {
    const request = await fetch(`${url}${basePath}/supply/distribution`);
    const response = await request.json();
    const formatedData = (0, format_1.formatTokenDistribution)(response);
    return formatedData;
};
exports.getTokenDistribution = getTokenDistribution;
const getBalanceListByPage = async (n, rowPerPage) => {
    const request = await fetch(`${url}${basePath}/balance/list?page=${n}&limit=${rowPerPage ? rowPerPage : 10}`);
    const response = await request.json();
    const formatedData = (0, format_1.formatBalanceListByPage)(response);
    return formatedData;
};
exports.getBalanceListByPage = getBalanceListByPage;
const getSupplyMetrics = async () => {
    const request = await fetch(`${url}${basePath}/supply/metrics`);
    const response = await request.json();
    return (0, format_1.formatSupplyMetrics)(response);
};
exports.getSupplyMetrics = getSupplyMetrics;
const getGovernanceMetrics = async () => {
    const request = await fetch(`${url}${basePath}/governance/metrics`);
    const response = await request.json();
    return (0, format_1.formatGovernanceMetrics)(response);
};
exports.getGovernanceMetrics = getGovernanceMetrics;
const getExchangeRateOGY = async () => {
    const request = await fetch(`${url}${basePath}/price`);
    const response = await request.json();
    return response;
};
exports.getExchangeRateOGY = getExchangeRateOGY;
const getGovernanceList = async (n, rowPerPage) => {
    const request = await fetch(`${url}${basePath}/governance/balance/list?page=${n ? n : 1}&limit=${rowPerPage ? rowPerPage : 10}`);
    const response = await request.json();
    const formatedData = (0, format_1.formatGovernanceList)(response);
    return formatedData;
};
exports.getGovernanceList = getGovernanceList;
const getBalanceWithGovernanceList = async (n, rowPerPage, totalSupply) => {
    const request = await fetch(`${url}${basePath}/balance/list-with-governance?page=${n ? n : 1}&limit=${rowPerPage ? rowPerPage : 10}`);
    const response = await request.json();
    const formatedData = (0, format_1.formatBalanceWithGovernanceList)(response, totalSupply);
    return formatedData;
};
exports.getBalanceWithGovernanceList = getBalanceWithGovernanceList;
const getGovernanceStakesList = async (n, rowPerPage) => {
    const request = await fetch(`${url}${basePath}/governance/assets/list/staked?page=${n ? n : 1}&limit=${rowPerPage ? rowPerPage : 10}`);
    const response = await request.json();
    const formatedData = (0, format_1.formatStakesList)(response);
    return formatedData;
};
exports.getGovernanceStakesList = getGovernanceStakesList;
const getStakesByPrincipal = async (principal) => {
    const request = await fetch(`${url}${basePath}/governance/assets/${principal}`);
    const response = await request.json();
    const formatedStakes = (0, format_1.formatPrincipalStakesList)(response.staking);
    const formatedVesting = (0, format_1.formatPrincipalStakesList)(response.vesting);
    return {
        stakes: formatedStakes,
        vestings: formatedVesting,
    };
};
exports.getStakesByPrincipal = getStakesByPrincipal;
const getMultiDatasCard = async () => {
    const request = await fetch(`${url}${basePath}/governance/metrics`);
    const response = await request.json();
    return (0, format_1.formatMultiDatasCard)(response);
};
exports.getMultiDatasCard = getMultiDatasCard;
const getMetrics = async () => {
    const request = await fetch(`${url}${basePath}/metrics`);
    const response = await request.json();
    return response;
};
exports.getMetrics = getMetrics;
const getUsersTimeseries = async () => {
    const request = await fetch(`${url}${basePath}/supply/accounts`);
    const response = await request.json();
    return response;
};
exports.getUsersTimeseries = getUsersTimeseries;
const getStakesTimeseries = async () => {
    const request = await fetch(`${url}${basePath}/governance/timeseries?days=720`);
    const response = await request.json();
    return response;
};
exports.getStakesTimeseries = getStakesTimeseries;
const getOrigynForecast = async () => {
    const request = await fetch(`${url}${basePath}/governance/forecast/timeseries`);
    const response = await request.json();
    return (0, format_1.formatOrigynForecast)(response);
};
exports.getOrigynForecast = getOrigynForecast;
const getGovernanceBalanceById = async (id) => {
    const balanceReq = await fetch(`${url}${basePath}/governance/balance/${id}`);
    const res = await balanceReq.json();
    return (0, format_1.formatGovernanceBalanceById)(res);
};
exports.getGovernanceBalanceById = getGovernanceBalanceById;
const getGovernanceAssetsById = async (id) => {
    const assetsReq = await fetch(`${url}${basePath}/governance/assets/${id}`);
    const res = await assetsReq.json();
    return (0, format_1.formatGovernanceAssetsById)(res);
};
exports.getGovernanceAssetsById = getGovernanceAssetsById;
const getLedgerTimeseriesById = async (id) => {
    const req = await fetch(`${url}${basePath}/balance/history/${id}`);
    const res = await req.json();
    return (0, format_1.formatLedgerTimeseriesById)(res);
};
exports.getLedgerTimeseriesById = getLedgerTimeseriesById;
const getProposalsTimeseries = async () => {
    const req = await fetch(`${url}${basePath}/governance/timeseries/proposals-stats?days=720`);
    const res = await req.json();
    return (res);
};
exports.getProposalsTimeseries = getProposalsTimeseries;
const getTransactionHistoryById = async (id, page, limit) => {
    const response = await fetch(`${ROSETTA_URL}/search/transactions`, {
        method: 'POST',
        body: JSON.stringify({
            network_identifier: NET_ID,
            account_identifier: {
                address: id,
            },
            offset: (page - 1) * limit,
            limit,
        }),
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    });
    const r = await response.json();
    return (0, format_1.formatTransactionHistoryById)(r, page, limit);
};
exports.getTransactionHistoryById = getTransactionHistoryById;
const getTransactionHistory = async (page, limit) => {
    const response = await fetch(`${ROSETTA_URL}/network/status`, {
        method: 'POST',
        body: JSON.stringify({
            network_identifier: NET_ID,
        }),
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    });
    const pr = await response.json();
    const promises = [];
    for (let i = 0; i < limit; i++) {
        const index = pr.current_block_identifier.index - ((page - 1) * limit) - i;
        if (index >= 0) {
            const r = fetch(`${ROSETTA_URL}/block`, {
                method: 'POST',
                body: JSON.stringify({
                    network_identifier: NET_ID,
                    block_identifier: {
                        index: index,
                    },
                }),
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            promises.push(r);
        }
    }
    const allData = await Promise.all(promises);
    const allDataJson = await Promise.all(allData.map(async (item) => await item.json()));
    const fRes = {
        data: allDataJson.map((item) => ({
            amount: (0, format_1.formatNatAmount)(BigInt(Math.abs(item.block.transactions[0].operations[0].amount.value))),
            fee: 0.002,
            from: item.block.transactions[0].operations[0]?.type === "MINT" ? "" : item.block.transactions[0].operations[0]?.account?.address,
            status: item.block.transactions[0].operations[0]?.status,
            timestamp: item.block.timestamp,
            to: item.block.transactions[0].operations[0]?.type === "MINT" ? item.block.transactions[0]?.operations[0]?.account?.address : item.block.transactions[0]?.operations[1]?.account?.address,
            txHash: item.block.block_identifier?.hash,
            type: item.block.transactions[0].operations[0]?.type
        })),
        limit,
        page,
        total: pr.current_block_identifier.index,
    };
    // const req = await fetch(`${url}${basePath}/transaction/history?page=${page}&limit=${limit}`);
    // const res = await req.json();
    return (0, format_1.formatTransactionHistory)(fRes);
};
exports.getTransactionHistory = getTransactionHistory;
const getTransactionDetailsByHash = async (txhash) => {
    const response = await fetch(`${ROSETTA_URL}/search/transactions`, {
        method: 'POST',
        body: JSON.stringify({
            network_identifier: NET_ID,
            block_identifier: {
                index: { hash: txhash },
            },
        }),
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    });
    const r = await fetch(`${ROSETTA_URL}/block`, {
        method: 'POST',
        body: JSON.stringify({
            network_identifier: NET_ID,
            block_identifier: {
                hash: txhash,
            },
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    const item = await r.json();
    // const req = await fetch(`${url}${basePath}/transaction/${txhash}`);
    // const res = await req.json();
    return (0, format_1.formatTransactionDetailsByTxhash)({
        amount: (0, format_1.formatNatAmount)(BigInt(Math.abs(item.block.transactions[0].operations[0].amount.value))),
        fee: 0.002,
        from: item.block.transactions[0].operations[0]?.type === "MINT" ? "" : item.block.transactions[0].operations[0]?.account?.address,
        status: item.block.transactions[0].operations[0]?.status,
        timestamp: item.block.timestamp,
        to: item.block.transactions[0].operations[0]?.type === "MINT" ? item.block.transactions[0]?.operations[0]?.account?.address : item.block.transactions[0]?.operations[1]?.account?.address,
        hash: item.block.block_identifier?.hash,
        type: item.block.transactions[0].operations[0]?.type,
        memo: item.block.transactions[0]?.metadata?.memo,
        block: item.block.transactions[0]?.metadata?.block_height
    });
};
exports.getTransactionDetailsByHash = getTransactionDetailsByHash;
const getTransactionDetailsByTxhash = async (txhash) => {
    const response = await fetch(`${ROSETTA_URL}/search/transactions`, {
        method: 'POST',
        body: JSON.stringify({
            network_identifier: NET_ID,
            transaction_identifier: { hash: txhash },
        }),
        headers: {
            'Content-Type': 'application/json',
            Accept: '*/*',
        },
    });
    const pr = await response.json();
    // const req = await fetch(`${url}${basePath}/transaction/${txhash}`);
    // const res = await req.json();
    return (0, format_1.formatTransactionDetailsByTxhash)({
        amount: (0, format_1.formatNatAmount)(BigInt(Math.abs(pr.transactions[0].transaction.operations[0].amount.value))),
        fee: 0.002,
        from: pr.transactions[0].transaction.operations[0]?.account?.address,
        status: pr.transactions[0].transaction.operations[0]?.status,
        timestamp: Math.floor(pr.transactions[0].transaction?.metadata?.timestamp / 1e6),
        memo: pr.transactions[0].transaction?.metadata?.memo,
        to: pr.transactions[0].transaction?.operations[1]?.account?.address,
        hash: pr.transactions[0].transaction?.transaction_identifier?.hash,
        type: pr.transactions[0].transaction?.operations[0]?.type,
        block: pr.transactions[0]?.block_identifier?.index
    });
};
exports.getTransactionDetailsByTxhash = getTransactionDetailsByTxhash;
const getSearchQuery = async (query) => {
    const req = await fetch(`${url}${basePath}/search?query=${query}`);
    const res = await req.json();
    return (0, format_1.formatSearchQuery)(res);
};
exports.getSearchQuery = getSearchQuery;
const getFoundationHolding = async () => {
    const req = await fetch(`${url}${basePath}/foundation/assets`);
    const res = await req.json();
    return (0, format_1.formatFoundationHolding)(res);
};
exports.getFoundationHolding = getFoundationHolding;
const getGovernanceForecastByMonths = async (m) => {
    const req = await fetch(`${url}${basePath}/governance/forecast?months=${m}`);
    const res = await req.json();
    return res;
};
exports.getGovernanceForecastByMonths = getGovernanceForecastByMonths;
